import React from 'react';
import DailyFeedbackDropdown from '../../UI/DailyFeedbackDropdown/DailyFeedbackDropdown';
// import DropDown from '../../UI/DropDown/DropDown';

import classes from './WeeklyFeedbackSection.module.css';
import { IsListEmpty, IsObjectEmpty, IsStringEmpty } from '../../../utilities/CommonMethods';
import ResourceAPIController from '../../../webServices/ResourceAPIController';
import ShowMiniLoader from '../../../hoc/ShowMiniLoader/ShowMiniLoader';
import StudentResponsePopup from '../../Popups/StudentResponsePopup/StudentResponsePopup';
import FilterIcon from '../../../assets/icons/filter-icon-white.svg';
import FilterDropDown from "../../UI/FilterDropDown/FilterDropDown";
import SortHelper from '../../../utilities/SortHelper';


class WeeklyFeedbackSection extends React.Component {

    state = {
        weeksList: [
            {
                id: 0,
                weekName: 'Week 1',
                weekDate: '7 February 2021 - 12 February 2021',
                name: 'Loading...'
            },
        ],
        activeFeedbackPos: 0,
        currentFeedbackId: 0,
        currentUserId: 0,
        currentFeedbackDetails: {},
        submissionsList: [],
        showTableLoader: true,

        showNameFilterDropdown: false,
        nameFilterItems: [{ id: 1, label: 'A -> Z' }, { id: 2, label: 'Z -> A' }],
        showRatingFilterDropdown: false,
        attendanceFilterItems: [{ id: 1, label: 'Highest' }, { id: 2, label: 'Lowest' }],
        activeNameFilterDropDownItem: -1,
        activeRatingFilterDropDownItem: -1,
        nameSearchFieldValue: '',
    }

    onNameFilterClicked = () => {
        let updatedState = this.state.showNameFilterDropdown;
        this.setState({ showNameFilterDropdown: !updatedState });
    }

    onRatingFilterClicked = () => {
        let updatedState = this.state.showRatingFilterDropdown;
        this.setState({ showRatingFilterDropdown: !updatedState });
    }

    onDropDownItemClicked = (pos, isRating) => {
        // alert(pos + ' something ' + isRating);
        let updatedList = [...this.state.submissionsList];

        if (isRating !== true) {
            // -------- Sort by Name --------
            if (pos === 0) {
                updatedList = SortHelper.sortStudentsByName(updatedList, 'ascending');
            } else {
                updatedList = SortHelper.sortStudentsByName(updatedList, 'descending');
            }
            this.setState({
                submissionsList: updatedList,
                activeNameFilterDropDownItem: pos,
                activeRatingFilterDropDownItem: -1,
                showNameFilterDropdown: false
            })
        } else {
            // -------- Sort by Rating --------
            if (pos === 0) {
                updatedList = updatedList.sort((a, b) => (b.rating - a.rating));
            } else {
                updatedList = updatedList.sort((a, b) => (a.rating - b.rating));
            }
            this.setState({
                submissionsList: updatedList,
                activeRatingFilterDropDownItem: pos,
                activeNameFilterDropDownItem: -1,
                showRatingFilterDropdown: false
            });
        }
    }

    nameSearchInputChangeHandler = (event) => {
        let updatedValue = event.target.value;
        this.setState({ nameSearchFieldValue: updatedValue });
    }

    onNameSearchIconClick = (searchString) => {
        const updatedSearchString = searchString.toLowerCase();
        const newList = this.state.fullSubmissionsList.filter(student => {
            if (student.name.toLowerCase().indexOf(updatedSearchString) !== -1) {
                return true;
            }
        });

        if (!IsListEmpty(newList)) {
            this.setState({ submissionsList: newList, showNameFilterDropdown: false, nameSearchFieldValue: searchString, activeNameFilterDropDownItem: -1, activeRatingFilterDropDownItem: -1 });
        } else {
            this.props.onFailureDialogShow('No student found with the matching name.', 'OKAY');
        }

    }

    clearSearchResults = () => {
        const updatedList = [...this.state.fullSubmissionsList];
        this.setState({ submissionsList: updatedList, activeNameFilterDropDownItem: -1, showNameFilterDropdown: false, nameSearchFieldValue: '' });
    }

    dropdownItemClicked = (pos) => {
        // alert('Clicked = ' + pos)
        let updatedCurrentFeedback = { ...this.state.weeksList[pos] };

        this.setState({
            activeFeedbackPos: pos,
            currentFeedbackDetails: updatedCurrentFeedback,
            currentFeedbackId: updatedCurrentFeedback.feedbackId,
            showTableLoader: true
        });
        this.getParticularWeekFeedbackReport(updatedCurrentFeedback.feedbackId);
    }

    getWeeklyFeedbackReport = () => {

        ResourceAPIController.getInstructorWeeklyFeedbackReport(this.props.batchCode, this.props.moduleName)
            .then(response => {

                // console.log('getInstructorWeeklyFeedbackReport Data => ', response.result);

                this.setState({
                    showTableLoader: false,
                    weeksList: response.result.weeksList,
                    currentFeedbackDetails: response.result.weeksList[0],
                    currentFeedbackId: response.result.weeksList[0].feedbackId,
                    submissionsList: response.result.submissionsList,
                    fullSubmissionsList: response.result.submissionsList
                });

            })
            .catch(err => {
                console.log('getInstructorWeeklyFeedbackReport error => ', err)
                this.setState({ showTableLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                if (err.error.status === 400) {
                    this.props.onFailureDialogShow(err.error.message, 'OKAY');
                }
                if (err.error.status === 401) {
                    if (err.error.message === 'Invalid token.') {
                        this.props.showSessionExpiredDialog(true);
                    } else {
                        this.props.redirectToUnauthorized();
                    }
                }
                if (err.error.status === 404) {
                    this.props.redirectToNotFound();
                }
                if (err.error.status === 500) {
                    this.props.redirectToServerError();
                }
            });
    }

    getParticularWeekFeedbackReport = (feedbackId) => {

        ResourceAPIController.getFeedbackReportForParticularWeek(this.props.batchCode, this.props.moduleName, feedbackId)
            .then(response => {

                // console.log('getParticularWeekFeedbackReport Data => ', response.result);

                this.setState({
                    showTableLoader: false,
                    // weeksList: response.result.weeksList,
                    // currentFeedbackDetails: response.result.weeksList[0],
                    submissionsList: response.result.submissionsList,
                    fullSubmissionsList: response.result.submissionsList
                })

            })
            .catch(err => {
                console.log('getParticularWeekFeedbackReport error => ', err)
                this.setState({ showTableLoader: false, showCardLoader: false });
                if (IsObjectEmpty(err.error)) {
                    // LogParsingError('ParsingError: MainLayout: ' + err.toString(), EndPoints.SIGNED_IN_COMMON_DATA, responseObj);
                    return;
                }
                // if (err.error.status === 400) {
                //     this.props.onFailureDialogShow(err.error.message, 'OKAY');
                // }
                // if (err.error.status === 401) {
                //     this.props.redirectToUnauthorized();
                // }
                // if (err.error.status === 404) {
                //     this.props.redirectToNotFound();
                // }
                // if (err.error.status === 500) {
                //     this.props.redirectToServerError();
                // }
            });
    }

    showStudentResponsePopup = (userId) => {
        // alert('student response => ' + userId);
        this.setState({ showStudentResponsePopup: true, currentUserId: userId });

    }

    closePopup = () => {
        this.setState({ showStudentResponsePopup: false, currentUserId: 0 });
    }

    componentDidMount() {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (!IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)) {
            this.getWeeklyFeedbackReport(batchCode, moduleName);
        }
    }

    componentDidUpdate(prevProps) {
        const batchCode = this.props.batchCode, moduleName = this.props.moduleName;
        if (prevProps.batchCode !== this.props.batchCode || prevProps.moduleName !== this.props.moduleName) {
            this.getWeeklyFeedbackReport(batchCode, moduleName);
        }
    }


    render() {

        const submissionsList = !IsListEmpty(this.state.submissionsList) ? this.state.submissionsList.map((submission, index) => {
            return (
                <tr key={index}>
                    <td>{index + 1}</td>
                    <td className={classes.Link} onClick={() => this.showStudentResponsePopup(submission.userId)}>{submission.name}</td>
                    <td className={classes.SubmissionTimeTD}>{submission.submissionTime}</td>
                    <td className={classes.RatingTD}>{submission.rating} / 10</td>
                    <td className={[classes.Link, classes.CenterAlign].join(' ')} onClick={() => this.showStudentResponsePopup(submission.userId)}>Feedback</td>
                </tr>
            );
        }) : null;

        return (
            <div className={classes.WeeklyFeedbackSectionContainer}>

                {
                    this.state.showStudentResponsePopup
                        ? <StudentResponsePopup
                            show={this.state.showStudentResponsePopup}
                            weekName={this.state.currentFeedbackDetails.weekName}
                            forWeekly={true}
                            feedbackId={this.state.currentFeedbackId}
                            userId={this.state.currentUserId}
                            closePopup={this.closePopup}
                        />
                        : null
                }
                <h2 className={classes.ReportHeading}>
                    {
                        this.props.forPMPage === true ? 'Weekly Feedback' : 'Weekly Feedback Report'
                    }
                </h2>

                <DailyFeedbackDropdown
                    dropdownItemsList={this.state.weeksList}
                    activeItemPos={this.state.activeFeedbackPos}
                    dropdownItemClicked={this.dropdownItemClicked}
                    forWeekly={true}
                />

                <hr className={classes.Divider} />

                <div className={classes.ReportSection}>
                    <h3 className={classes.ReportSubHeading}>{this.state.currentFeedbackDetails.weekName}</h3>
                    <p className={classes.DateText}>{this.state.currentFeedbackDetails.weekDate}</p>

                    <table className={classes.Table}>
                        <thead className={classes.TableHeadings}>
                            <tr>
                                <th className={classes.SrNo}>Sr.No.</th>
                                <th className={classes.StudentNameTH}>
                                    <div className={classes.CenterAlignTh}>
                                        STUDENT NAME
                                        <img src={FilterIcon} onClick={this.onNameFilterClicked} alt={'Student Name filter sort icon'} className={classes.FilterIcon} />
                                        {this.state.showNameFilterDropdown
                                            ? <div className={classes.Dropdown}>
                                                <FilterDropDown
                                                    itemList={this.state.nameFilterItems}
                                                    onDropDownClicked={this.onNameFilterClicked}
                                                    onDropDownItemClicked={this.onDropDownItemClicked}
                                                    activeItem={this.state.activeNameFilterDropDownItem}
                                                    searchFieldValue={this.state.nameSearchFieldValue}
                                                    inputChangeHandler={this.nameSearchInputChangeHandler}
                                                    onSearchIconClick={this.onNameSearchIconClick}
                                                    clearSearchResults={this.clearSearchResults}
                                                    searchString={this.state.nameSearchFieldValue}
                                                    forNumber={false}
                                                />
                                            </div>
                                            : null}
                                    </div>
                                </th>
                                <th className={classes.SubmissionTimeTH}>SUBMISSION TIME</th>
                                <th className={classes.RatingTH}>
                                    <div className={classes.CenterAlignTh}>
                                        EDYODA RATING
                                        <img src={FilterIcon} onClick={this.onRatingFilterClicked} alt={'EdYoda Rating filter sort icon'} className={classes.FilterIcon} />
                                        {this.state.showRatingFilterDropdown
                                            ? <div className={[classes.Dropdown, classes.RatingDropdown].join(' ')}>
                                                <FilterDropDown
                                                    itemList={this.state.attendanceFilterItems}
                                                    onDropDownClicked={this.onRatingFilterClicked}
                                                    onDropDownItemClicked={this.onDropDownItemClicked}
                                                    activeItem={this.state.activeRatingFilterDropDownItem}
                                                    forNumber={true}
                                                />
                                            </div>
                                            : null}
                                    </div>
                                </th>
                                <th className={classes.ResponseLinkTH}>RESPONSE LINK</th>
                            </tr>
                        </thead>
                        <tbody className={[classes.TableBody, classes.StudentsTable].join(' ')}>

                            {this.state.showTableLoader
                                ? <tr>
                                    <td colSpan="5" className={classes.AlignCenter}>
                                        <ShowMiniLoader isLoading={true} transparentBg={true} />
                                    </td>
                                </tr>
                                : !IsListEmpty(submissionsList)
                                    ? submissionsList
                                    : <tr>
                                        <td colSpan="5" className={classes.AlignCenter}>Submissions Not Available!</td>
                                    </tr>}

                        </tbody>
                    </table>
                </div>

            </div >
        );
    }
}

export default WeeklyFeedbackSection;